import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/i18n-react';
import { PAGE_NAME } from '../../../../monitoring';
import { AddEmptyBlock } from '../../AddEmptyBlock';
import styles from './AddNotableClientsBlock.module.scss';

interface AddNotableClientsBlockProps {
    username: string;
}

const T_PREFIX = 'freelancer_page.notable_clients.empty';

const getEditNotableClientsUrl = (username: AddNotableClientsBlockProps['username']) =>
    pathfinder('notable_clients_render', { username }, { query: { source: PAGE_NAME } });

const mpEventsConfig = {
    type: 'freelancer page view NC empty state',
    clickType: 'freelancer page clicked add NC',
};

export const AddNotableClientsBlock: React.FC<AddNotableClientsBlockProps> = ({ username }) => (
    <AddEmptyBlock
        className={styles.emptyClientsBlock}
        leftContent={<div className={styles.image} />}
        contentWrapperClassName={styles.contentWrapper}
        descriptionTitle={<I18n k={`${T_PREFIX}.title`} />}
        description={<I18n k={`${T_PREFIX}.description`} />}
        buttonText={<I18n k={`${T_PREFIX}.add_button`} />}
        buttonHref={getEditNotableClientsUrl(username)}
        mpEvents={mpEventsConfig}
        isPrivate
    />
);
